import React from "react";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import { useKnowledgeLibraryContext, useKnowledgeContext, KnowledgeCard, findKnowledgeLogo } from "@limitless/portal";
import { usePageViewRecorder } from "@limitless/analytics";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Box from "@limitless/modern/layout/Box";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import { useExpertProfileContext } from "@limitless/expert";
import { useNavigation, LoadingSpinner } from "@limitless/portal";

const useStyles = makeStyles(() => ({
    container: {
        overflowY: "auto",
        height: "100vh"
    },
    knowledgeCardContainer: {
        paddingTop: "80px",
        paddingBottom: "80px"
    },
    centerText: {
        textAlign: "center"
    },
    subText: {
        marginTop: "32px",
        marginBottom: "35px"
    },
    knowledgeContainer: {
        marginLeft: 33
    },
    headingContainer: {
        display: "flex",
        flex: 1,
        marginTop: 20,
        marginBottom: 30,
        alignItems: "center"
    },
    searchContainer: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end"
    }
}));

const KnowledgeScreen = () => {
    const classes = useStyles();
    const { isDarkMode } = useExpertProfileContext();
    const { libraries } = useKnowledgeContext();
    const { updateSelectedLibrary, setLibraryToLoad } = useKnowledgeLibraryContext();
    const { filteredList, loading } = libraries;
    const { navigate } = useNavigation();
    usePageViewRecorder("Knowledge");

    const handleKnowledgeItemClick = listItem => {
        setLibraryToLoad({ groupName: listItem.groupName, tenantName: listItem.tenantName });
        updateSelectedLibrary(listItem);
        navigate(`/knowledge/${listItem.displayName}`);
    };

    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    return (
        <ThemeProvider theme={theme}>
            <Box className={classes.container}>
                <Grid container justifyContent="center" direction="column" className={classes.knowledgeCardContainer}>
                    <Grid alignItems="center" className={classes.centerText}>
                        <Typography variant="h6"  sx={{ color: theme => theme.palette.text.primary }}>{"Looking for answers to customers’ questions?"}</Typography>
                        <Typography variant="h6"  sx={{ color: theme => theme.palette.text.primary }}>{"We got you covered"}</Typography>
                    </Grid>
                    <Grid className={`${classes.centerText} ${classes.subText}`}>
                        <Typography variant="subtitle1" sx={{ color: theme => theme.palette.grey[4] }}>
                            {"Select Brand"}
                        </Typography>
                    </Grid>
                    <Grid container justifyContent="center" direction="row" columnSpacing={7} rowSpacing={5}>
                        {loading ? (
                            <Grid mt={1}>
                                <LoadingSpinner />
                            </Grid>
                        ) : (
                            filteredList.map((listItem, index) => (
                                <Grid item key={index}>
                                    <KnowledgeCard
                                        title={listItem.displayName ? listItem.displayName : listItem.groupName}
                                        imageSource={findKnowledgeLogo(listItem.groupName, listItem.knowledgeLogos)}
                                        onClick={() => handleKnowledgeItemClick(listItem)}
                                        id={`knowledgeBaseButton${index}`}
                                    />
                                </Grid>
                            ))
                        )}
                    </Grid>
                </Grid>
            </Box>
        </ThemeProvider>
    );
};

export default KnowledgeScreen;
